import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icons/basket.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-658da23b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "marketplace-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "h2 mx-4 mt-4" }, "Каталог товаров и поставщиков", -1))
const _hoisted_3 = { class: "marketplace-page__container d-flex" }
const _hoisted_4 = { class: "filters col-md-3" }
const _hoisted_5 = { class: "filter-block" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Сортировать", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "popularity" }, "По популярности", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "price-asc" }, "По цене: от низкой к высокой", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "price-desc" }, "По цене: от высокой к низкой", -1))
const _hoisted_10 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "filter-block" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Стоимость", -1))
const _hoisted_13 = { class: "price-range d-flex" }
const _hoisted_14 = { class: "filter-block" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "dropdown w-100" }
const _hoisted_17 = { class: "dropdown-content" }
const _hoisted_18 = ["onMouseenter"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["for"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "›", -1))
const _hoisted_22 = {
  key: 0,
  class: "subcategory-popup"
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "col flex-grow-1 ms-md-4" }
const _hoisted_26 = { class: "marketplace products-container col flex-grow-1 ms-md-4 mb-4" }
const _hoisted_27 = { class: "marketplace_categories" }
const _hoisted_28 = ["translate", "onClick"]
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = ["src"]
const _hoisted_31 = { class: "marketplace products-container col flex-grow-1 ms-md-4" }
const _hoisted_32 = { class: "filter-header" }
const _hoisted_33 = { class: "applied-filters" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Примененные фильтры:", -1))
const _hoisted_35 = { class: "filter-tags" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = {
  id: "products-list",
  class: "product-list row mt-4 gy-3 gx-2"
}
const _hoisted_39 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-muted",
  translate: "yes"
}, "Товары не найдены", -1))
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = {
  key: 1,
  class: "pagination-section mt-5 mb-5"
}
const _hoisted_43 = { class: "d-flex flex-column align-items-center" }
const _hoisted_44 = {
  class: "pagination-info mb-3",
  translate: "yes"
}
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { class: "pagination pagination-custom flex-wrap justify-content-center" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "d-none d-md-inline",
  translate: "yes"
}, "Назад", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-md-none" }, "←", -1))
const _hoisted_49 = [
  _hoisted_47,
  _hoisted_48
]
const _hoisted_50 = ["onClick"]
const _hoisted_51 = {
  key: 1,
  class: "page-item disabled"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "page-link" }, "...", -1))
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "d-none d-md-inline",
  translate: "yes"
}, "Вперед", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-md-none" }, "→", -1))
const _hoisted_56 = [
  _hoisted_54,
  _hoisted_55
]
const _hoisted_57 = { class: "icon-wrapper" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Cart",
  class: "cart-icon"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductCard = _resolveComponent("ProductCard")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("aside", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedSort) = $event)),
              class: "form-control"
            }, _hoisted_10, 512), [
              [_vModelSelect, _ctx.selectedSort]
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.minPrice) = $event)),
                class: "form-control me-2 no-arrows",
                type: "number",
                placeholder: "От",
                onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.minPrice = _ctx.minPrice === '' ? null : _ctx.minPrice)),
                onKeydown: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.preventNegativeInput && _ctx.preventNegativeInput(...args)))
              }, null, 544), [
                [
                  _vModelText,
                  _ctx.minPrice,
                  void 0,
                  { number: true }
                ]
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.maxPrice) = $event)),
                class: "form-control ms-2",
                type: "number",
                placeholder: "До",
                onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.maxPrice = _ctx.maxPrice === '' ? null : _ctx.maxPrice)),
                onKeydown: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.preventNegativeInput && _ctx.preventNegativeInput(...args)))
              }, null, 544), [
                [
                  _vModelText,
                  _ctx.maxPrice,
                  void 0,
                  { number: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("h3", null, [
              _createTextVNode(" Выбрать категории "),
              (_ctx.selectedCategories.length)
                ? (_openBlock(), _createElementBlock("span", _hoisted_15, "(" + _toDisplayString(_ctx.selectedCategories.length) + ")", 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: category.id,
                    class: "dropdown-item__wrapper",
                    onMouseenter: ($event: any) => (_ctx.hoveredCategory = category),
                    onMouseleave: _cache[7] || (_cache[7] = ($event: any) => (_ctx.hoveredCategory = null))
                  }, [
                    _createElementVNode("div", {
                      class: "dropdown-item",
                      onClick: ($event: any) => (_ctx.handleParentClick(category))
                    }, [
                      _createElementVNode("label", {
                        for: 'category-' + category.id
                      }, [
                        _createTextVNode(_toDisplayString(category.name) + " ", 1),
                        _hoisted_21
                      ], 8, _hoisted_20)
                    ], 8, _hoisted_19),
                    (_ctx.hoveredCategory?.id === category.id && _ctx.hoveredCategory.childrens?.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hoveredCategory.childrens, (sub) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: sub.id,
                              class: "subcategory-item"
                            }, [
                              _createElementVNode("strong", {
                                onClick: _withModifiers(($event: any) => (_ctx.toggleCategory(sub)), ["stop"])
                              }, _toDisplayString(sub.name) + " ›", 9, _hoisted_23),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sub.childrens, (child) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: child.id,
                                  class: "subcategory-item__child",
                                  onClick: _withModifiers(($event: any) => (_ctx.toggleCategory(child)), ["stop"])
                                }, _toDisplayString(child.name), 9, _hoisted_24))
                              }), 128))
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ], 40, _hoisted_18))
                }), 128))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index + category.name,
                  class: "marketplace_categories__item",
                  translate: _ctx.isClicked ? 'no' : 'yes',
                  onClick: ($event: any) => (_ctx.toggleCategory(category))
                }, [
                  _createElementVNode("span", {
                    class: "category-title",
                    innerHTML: category.name
                  }, null, 8, _hoisted_29),
                  _createElementVNode("img", {
                    src: category.image,
                    alt: ""
                  }, null, 8, _hoisted_30)
                ], 8, _hoisted_28))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _hoisted_34,
                _createElementVNode("div", _hoisted_35, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appliedFilters, (filter) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: filter,
                      class: "filter-tag"
                    }, [
                      _createTextVNode(_toDisplayString(filter) + " ", 1),
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.removeFilter(filter))
                      }, "×", 8, _hoisted_36)
                    ]))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedCategories, (category) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: category.id,
                      class: "filter-tag"
                    }, [
                      _createTextVNode(_toDisplayString(category.name) + " ", 1),
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.removeFilter(category.id))
                      }, "×", 8, _hoisted_37)
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredProducts, (product, index) => {
                return (_openBlock(), _createBlock(_component_ProductCard, {
                  key: index,
                  class: "col-lg-3 col-md-4 col-6",
                  product: product
                }, null, 8, ["product"]))
              }), 128))
            ]),
            (_ctx.totalCount === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_39, _hoisted_41))
              : _createCommentVNode("", true),
            (_ctx.totalCount > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("p", _hoisted_44, [
                      _createTextVNode(" Показано "),
                      _createElementVNode("b", null, _toDisplayString(_ctx.products.length), 1),
                      _createTextVNode(" из "),
                      _createElementVNode("b", null, _toDisplayString(_ctx.totalCount), 1)
                    ]),
                    (_ctx.totalPages > 1)
                      ? (_openBlock(), _createElementBlock("nav", _hoisted_45, [
                          _createElementVNode("ul", _hoisted_46, [
                            _createElementVNode("li", {
                              class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === 1 }])
                            }, [
                              _createElementVNode("button", {
                                class: "page-link",
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.changePage(_ctx.currentPage - 1)))
                              }, _hoisted_49)
                            ], 2),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (page) => {
                              return (_openBlock(), _createElementBlock(_Fragment, { key: page }, [
                                (page === 1 || page === _ctx.totalPages || Math.abs(page - _ctx.currentPage) <= (_ctx.isMobile ? 1 : 2))
                                  ? (_openBlock(), _createElementBlock("li", {
                                      key: 0,
                                      class: _normalizeClass(["page-item", { active: _ctx.currentPage === page }])
                                    }, [
                                      _createElementVNode("button", {
                                        class: "page-link",
                                        onClick: ($event: any) => (_ctx.changePage(page))
                                      }, _toDisplayString(page), 9, _hoisted_50)
                                    ], 2))
                                  : (Math.abs(page - _ctx.currentPage) === (_ctx.isMobile ? 2 : 3))
                                    ? (_openBlock(), _createElementBlock("li", _hoisted_51, _hoisted_53))
                                    : _createCommentVNode("", true)
                              ], 64))
                            }), 128)),
                            _createElementVNode("li", {
                              class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === _ctx.totalPages }])
                            }, [
                              _createElementVNode("button", {
                                class: "page-link",
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.changePage(_ctx.currentPage + 1)))
                              }, _hoisted_56)
                            ], 2)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    (_ctx.isLoggedIn && _ctx.cartCount > 0)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: "/profile/basket",
          class: _normalizeClass(["floating-cart-btn", { 'with-bar': _ctx.isMobile }])
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_57, [
              _hoisted_58,
              _createVNode(_Transition, { name: "pop" }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock("span", {
                    key: _ctx.cartCount,
                    class: "cart-badge"
                  }, _toDisplayString(_ctx.cartCount), 1))
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["class"]))
      : _createCommentVNode("", true)
  ], 64))
}